import { definePreset, palette } from '@primeng/themes';
// import BaseTheme from '@primeng/themes/aura';
import BaseTheme from '@primeng/themes/lara';
// import BaseTheme from '@primeng/themes/material';
import {
  accordion,
  autocomplete,
  badge,
  button,
  card,
  checkbox,
  chip,
  datatable,
  datepicker,
  dialog,
  divider,
  drawer,
  editor,
  iconfield,
  inputgroup,
  inputtext,
  menu,
  message,
  multiselect,
  paginator,
  popover,
  progressbar,
  select,
  selectbutton,
  skeleton,
  stepper,
  tag,
  textarea,
  tieredmenu,
  togglebutton,
  toggleswitch,
  treeselect,
  scrolltop,
} from './components';

// const testPalette = palette('#55c013');
// const primaryColorPalette = palette('#1E3A8A');
// const primaryColorPalette = palette('#003c5b');
// const primaryColorPalette = palette('#45bfa2');
// const primaryColorPalette = palette('#299292');
// const primaryColorPalette = palette('#008081');
// const primaryColorPalette = palette('#00615b');
// const primaryColorPalette = palette('#5BB6B0'); // Color del logo
const primaryColorPalette = palette('#228f88');
const primaryDarkColorPalette = palette('#12635f');
const accentColorPalette = palette('#299292'); // teal (antes primario)
const secondaryColorPalette = palette('#0574A4');
const surfaceDarkPalette = palette('#333643');
const surfaceLightPalette = palette('#efefef');
// console.log(surfaceDarkPalette);
// console.log(surfaceLightPalette);

const CustomTheme = definePreset(BaseTheme, {
  semantic: {
    // primary: testPalette,
    primary: primaryColorPalette,
    primaryDark: primaryDarkColorPalette,
    secondary: secondaryColorPalette, // tokens --p-secondary-*
    font: {
      family:
        'Inter var, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      featureSettings: '"cv02", "cv03", "cv04", "cv11"',
    },
    // primary: {
    //   50: '{blue.50}',
    //   100: '{blue.100}',
    //   200: '{blue.200}',
    //   300: '{blue.300}',
    //   400: '{blue.400}',
    //   500: '{blue.500}',
    //   600: '{blue.600}',
    //   700: '{blue.700}',
    //   800: '{blue.800}',
    //   900: '{blue.900}',
    //   950: '{blue.950}',
    // },
    // accentColor: accentColorPalette,

    colorScheme: {
      light: {
        themeMode: 'light',
        color: '{neutral.50}',
        textColor: '{neutral.600}',
        inverseTextColor: '{neutral.50}',
        primary: {
          color: '{primary.500}',
          inverseColor: '{primary.50}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.500}',
        },
        secondary: {
          color: '{secondary.500}',
          inverseColor: '{secondary.50}',
          hoverColor: '{secondary.700}',
          activeColor: '{secondary.600}',
        },
        severityColor: {
          success: '#35b481',
          warning: '#ce8a3e',
          info: '#45bfa2',
          danger: '#c5545d',
          disabled: '#b3c2c7ff',
          border: {
            success: '#27a572',
            warning: '#ac702b',
            info: '#45bfa2',
            danger: '#b9404a',
            disabled: '#cadae0',
          },
        },
        bgColor: '#ffffff',
        surface: {
          0: '#ffffff',
          '50': '#fefefe',
          '100': '#fbfbfb',
          '200': '#f8f8f8',
          '300': '#f5f5f5',
          '400': '#f2f2f2',
          '500': '#efefef',
          '600': '#cbcbcb',
          '700': '#a7a7a7',
          '800': '#838383',
          '900': '#606060',
          '950': '#3c3c3c',
        },
        // cardBgColor: '#f8f8f8',
        cardBgColor: '#ffffff',
        formField: {
          background: '#ffffff',
          hoverBorderColor: '{blue.500}',
          placeholder: {
            color: '{text.color}',
          },
          disabled: {
            background: '#cbcbcb',
            color: '#9c9c9c',
          },
        },
        sidebar: {
          logo: {
            // bgColor: '{primary.500}',
            bgColor: '{gray.800}',
          },
          bgColor: 'white',
          color: '{black.50}',
          hoverColor: '{white.100}',

          /* Active MenuItem */
          menuitem: {
            textColor: '#333',
            textIconColor: '#1e88e5',
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.500}',
            },
            hover: {
              bgColor: '{primary.200}',
              textColor: '#212121',
              iconTextColor: '#212121',
            },
          },
          submenuitem: {
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.400}',
            },
            // activeBgColor: '{red.500}',
          },
        },
        header: {
          menu: {
            iconColor: '{neutral.50}',
            // bgColor: '{primary.500}',
            bgColor: '{gray-800}',
            // bgColor: 'white',
          },
        },
        icons: {
          color: '#45bfa2',
        },
        mobile: {
          contentMaskBgColor: '424242',
        },
      },
      dark: {
        themeMode: 'dark',
        color: 'white',
        textColor: 'white',
        inverseTextColor: '{neutral.900}',
        primary: {
          color: '{primaryDark.500}',
          inverseColor: '{primaryDark.100}',
          hoverColor: '{primaryDark.300}',
          activeColor: '{primaryDark.200}',
        },
        secondary: {
          color: '{secondary.400}',
          inverseColor: '{secondary.50}',
          hoverColor: '{secondary.300}',
          activeColor: '{secondary.200}',
        },
        severityColor: {
          success: '#35b481b9',
          warning: '#ce8b3ec4',
          info: '#45bfa2',
          danger: '#c5545dc0',
          disabled: '#b3c2c7be',
          border: {
            success: '#27a573b4',
            warning: '#ac702bbe',
            info: '#45bfa2',
            danger: '#b9404ab9',
            disabled: '#cadae0a8',
          },
        },
        // highlight: {
        //   background: '#f00',
        //   focusBackground: '#ff1',
        //   color: 'rgba(255,255,255,.87)',
        //   focusColor: 'rgba(255,255,255,.87)',
        // },
        // surface: {
        //   0: '#ffffff',
        //   50: '{slate.50}',
        //   100: '{slate.100}',
        //   200: '{slate.200}',
        //   300: '{slate.300}',
        //   400: '{slate.400}',
        //   500: '{slate.500}',
        //   600: '{slate.600}',
        //   700: '{slate.700}',
        //   800: '{slate.800}',
        //   900: '{slate.900}',
        //   950: '{slate.950}',
        // },
        bgColor: `$dt('surface.500')`,
        surface: {
          0: '#ffffff',
          '50': '#f5f5f6',
          '100': '#cecfd2',
          '200': '#a7a9ae',
          '300': '#81828a',
          '400': '#5a5c67',
          '500': '#333643',
          '600': '#2b2e39',
          '700': '#24262f',
          '800': '#1c1e25',
          '900': '#14161b',
          '950': '#0d0e11',
        },
        cardBgColor: '#3C434F',
        formField: {
          background: '#333643',
          hoverBorderColor: '{primary.color}',
          focusRing: {
            width: '2px',
            style: 'dashed',
            color: '{primary.color}',
            offset: '1px',
          },
          disabled: {
            background: '#3A3A49', // 4a4a5a
            color: '#4D4D55',
          },
        },
        sidebar: {
          logo: {
            bgColor: '{surface.700}',
          },
          bgColor: '{surface.600}',
          color: 'white',
          hoverColor: '{white.100}',

          /* Active MenuItem */
          menuitem: {
            textColor: 'white',
            textIconColor: '#1e88e5',
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.400}',
            },
            hover: {
              bgColor: '{primary.200}',
              textColor: '#212121',
              iconTextColor: '#212121',
            },
          },

          submenuitem: {
            active: {
              textColor: 'white',
              iconTextColor: 'white',
              bgColor: '{primary.400}',
            },
          },
        },
        header: {
          menu: {
            iconColor: '{neutral.50}',
            bgColor: '{surface.700}',
          },
        },
        icons: {
          color: '#45bfa2',
        },
        mobile: {
          contentMaskBgColor: '424242',
        },
        topbar: {
          bgColor: '{surface.600}',
          color: '{neutral.50}',
        },
      },
    },
    mobile: {
      breakpoint: '1024px',
    },
    borderRadius: '3px',
    fontSize: '1rem',
    transitionDuration: '0.3s',
    topbar: {
      bgColor: '{neutral.50}',
      color: '{black.50}',
    },
  },

  components: {
    datatable,
    dialog,
    paginator,
    selectbutton,
    badge,
    togglebutton,
    editor,
    message,
    toggleswitch,
    progressbar,
    autocomplete,
    button,
    chip,
    drawer,
    card,
    inputgroup,
    iconfield,
    select,
    divider,
    multiselect,
    treeselect,
    checkbox,
    tieredmenu,
    tag,
    accordion,
    inputtext,
    textarea,
    stepper,
    skeleton,
    menu,
    datepicker,
    popover,
    scrolltop,
    // common tokens and styles
    // extend: {
    //   my: {
    //     transition: {
    //       slow: '0.75s',
    //       normal: '0.5s',
    //       fast: '0.25s',
    //     },
    //     imageDisplay: 'block',
    //   },
    // },
    // css: ({ dt }: { dt: (key: string) => string }) => `
    //     /* Global CSS */
    //     img {
    //         display: ${dt('my.image.display')};
    //     }
    // `,
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
  .p-component {
    font-family: var(--p-font-family);
    font-feature-settings: var(--p-font-feature-settings, normal);
    font-size: 1rem;
    font-weight: 400;
  }

  .p-button {
    font-family: inherit;
    font-feature-settings: inherit;
  }

  .p-overlay-mask {
    background: rgba(44, 62, 80, 0.3);
    backdrop-filter: blur(2px);
  }
`,
});

export { CustomTheme };
